import React, { Component } from 'react'
import classname from 'classnames';
import ReactTooltip from 'react-tooltip'
import '../../App.css';
import { connect } from 'react-redux';
import { ToggleQuestion } from '../../actions/FAQ.js';

class FAQ_Component extends Component {
  constructor(props) {
    super(props)
    this.state = {
      faq: [
        {
          question: 'What if I want a custom order or something other than proofreading?',
          answer: 'Easy! Contact us via Live Chat or via email at info@proofreadingmanuscripts.com so we can provide you with a custom solution.',
          active: false
        },
        {
          question: 'How do I know what to expect from my editor and what will you do for my paper?',
          answer: 'Check out examples of what your editor will do for you here: <a href="https://proofreadingmanuscripts.com/examples">Click Here</a>',
          active: false
        },
        {
          question: 'What will you edit and correct?',
          answer: 'Based on the package you choose, your expert will fix your: spelling, grammar, word choice, punctuation, flow, consistency, run-on sentences, sentence fragments, and punctuation. Editors will also provide comments to guide you through any necessary improvements.',
          active: false
        },
        {
          question: 'If I choose a quick turnaround time, such as 3 or 7 hours, do I actually get my paper back that fast?',
          answer: 'If the option is available, based on your word count in Step 1, you will get your paper back, fully edited, in the amount of time you chose, guaranteed. 24/7, including holidays.',
          active: false
        },
        {
          question: 'English is not my first language and I think my document may need a LOT of editing. Can you help?',
          answer: 'Yes, we can! We specialize in editing ESL writing and our editors have experience editing and correcting all levels of documents! You should select the ESL/Extra Editing additional service when you upload your essay in Step 3 so your editor is able to fully correct all possible writing mistakes.',
          active: false
        },
        {
          question: 'Do you edit for content or fact-check?',
          answer: 'With our Ultimate package, our experts will point out and attempt to fix obvious inaccuracies. Helpful comments will be left if something seems off so you have a chance to look it over.',
          active: false
        }
      ]
    }
  }
  ToggleQuestion(i){
    console.log("open question ", i);
    this.props.dispatch(ToggleQuestion(i, this.props.FAQ.array));
  }
  toggleFaq(i, e) {
    var faq = this.state.faq
    faq[i].active = ! faq[i].active
    this.setState({
      faq: faq
    })
  }
  render() {
    console.log("inside faq render" );
    var faqs = this.state.faq.map((faq, i) => {
                console.log("Inside the rendered faqs each one ----->----->----->")
                console.log(this.props.FAQ)
                console.log(faq);
               console.log("Inside the rendered faqs each one ----->----->----->")
      var answerVisible = classname({
        'popup': true,
        'faq-closed': this.props.FAQ.array.indexOf(i) < - 1,
        'faq-active': this.props.FAQ.array.indexOf(i) > - 1
      })
      return(
        <div className="qa">
          <h3 className="faq-question" onClick={this.ToggleQuestion.bind(this, i)}>{faq.question}</h3>
            <div className={answerVisible} dangerouslySetInnerHTML={{__html: faq.answer}} >
            </div>
        </div>
      )
    })
    return(
      <div className="faq">
        {faqs}
      </div>
    )
  }
}
export default connect(
  ({Paper, FAQ})=>({Paper, FAQ})
)(FAQ_Component);

// className="popup-wrap"
//  className="popup-body faq-answer"
//<p className={answerVisible}>{faq.answer}</p>
// <div className="popup-header">
//       <div className="close-popup" onClick={this.toggleFaq.bind(this, i)}><i className="fa fa-times" aria-hidden="true"></i></div>
// </div>



// WEBPACK FOOTER //
// ./src/components/steps/FAQ.js